import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLineModule, MatRippleModule } from '@angular/material/core';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterModule } from '@angular/router';
import { UiQuickpanelComponent } from './ui-quickpanel/ui-quickpanel.component';

@NgModule({
  imports: [CommonModule, MatListModule, MatProgressBarModule, RouterModule, MatRippleModule, MatLineModule],
  declarations: [UiQuickpanelComponent],
  exports: [UiQuickpanelComponent]
})
export class CoreLayoutFeatureQuickpanelModule {}
